var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.53827V3.53427C4 3.21227 4.182 3.03027 4.504 3.03027H6.009C7.059 3.03027 7.85 3.62527 7.85 4.70327C7.85 5.76027 7.059 6.43227 5.946 6.43227H5.015V7.53827C5.015 7.81827 4.791 8.04927 4.511 8.04927C4.231 8.04927 4 7.81827 4 7.53827ZM5.015 3.95427V5.50127H6.009C6.478 5.50127 6.835 5.22827 6.835 4.73127C6.835 4.23427 6.478 3.95427 6.009 3.95427H5.015Z",
    fill: "#323130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2609 8.00027H9.0779C8.7349 8.00027 8.5459 7.81127 8.5459 7.46827V3.56227C8.5459 3.21927 8.7349 3.03027 9.0779 3.03027H10.2609C11.8429 3.03027 12.7879 4.12227 12.7879 5.51527C12.7879 6.90827 11.8429 8.00027 10.2609 8.00027ZM9.5609 3.94727V7.08327H10.2609C11.1499 7.08327 11.7729 6.55827 11.7729 5.51527C11.7729 4.47227 11.1499 3.94727 10.2609 3.94727H9.5609Z",
    fill: "#323130"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.543 7.53827V3.56227C13.543 3.21927 13.732 3.03027 14.075 3.03027H16.217C16.462 3.03027 16.679 3.23327 16.679 3.49227C16.679 3.75127 16.462 3.94727 16.217 3.94727H14.558V5.10927H15.986C16.231 5.10927 16.434 5.31927 16.434 5.55727C16.434 5.80227 16.231 6.00527 15.986 6.00527H14.558V7.53827C14.558 7.87427 14.306 8.04227 14.054 8.04227C13.802 8.04227 13.543 7.87427 13.543 7.53827Z",
    fill: "#323130"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5C10 9.22386 10.2239 9 10.5 9C10.7761 9 11 9.22386 11 9.5V14.2929L12.1464 13.1464C12.3417 12.9512 12.6583 12.9512 12.8536 13.1464C13.0488 13.3417 13.0488 13.6583 12.8536 13.8536L10.8536 15.8536C10.6583 16.0488 10.3417 16.0488 10.1464 15.8536L8.14645 13.8536C7.95118 13.6583 7.95118 13.3417 8.14645 13.1464C8.34171 12.9512 8.65829 12.9512 8.85355 13.1464L10 14.2929V9.5Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.40694fb593c3a241f8a868b702cee626.svg";
export { ForwardRef as ReactComponent };